import { render } from "./EmployeeCalendar.vue?vue&type=template&id=96fdcdc6&ts=true"
import script from "./EmployeeCalendar.ts?vue&type=script&lang=ts&external"
export * from "./EmployeeCalendar.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__